import { render, staticRenderFns } from "./MusterModal.vue?vue&type=template&id=4506f097&"
import script from "./MusterModal.vue?vue&type=script&lang=js&"
export * from "./MusterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/pp-weberbuero-50965/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4506f097')) {
      api.createRecord('4506f097', component.options)
    } else {
      api.reload('4506f097', component.options)
    }
    module.hot.accept("./MusterModal.vue?vue&type=template&id=4506f097&", function () {
      api.rerender('4506f097', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/configurator/MusterModal.vue"
export default component.exports